import { Injectable } from '@angular/core';

import { environment } from '@app/environment';
import { ApiService } from '@app/services';
import { 
    BudgetQuotaConsumptionReport, CustomerSectorHourQuotaReport, ActionDone, TransferableHourQuotaReport, TransferableBudgetQuotaReport 
} from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class QuotaService {

    constructor(
        private apiService: ApiService
    ) {}
    
    async loadBudgetQuotaReport(operationId?: number): Promise<BudgetQuotaConsumptionReport|null> {
        let report: BudgetQuotaConsumptionReport|null = null;
        let params: any = {};
        if(operationId){
            params.operation = operationId;
        }
        let response = await this.apiService.get('order/budget-quota-report', params);
        if(response?.data){
            report = response.data;
        }
        return report;
    }
    
    async loadTransferableBudgetsQuotaReport(): Promise<TransferableBudgetQuotaReport|null> {
        let report: TransferableBudgetQuotaReport|null = null; 
        let response = await this.apiService.get('operation/transferable-budget-quota-report');
        if(response?.data){
            report = response.data;
        }        
        return report;
    }
    
    async loadExcelBudgetQuotaReport(operationId: number): Promise<string> {
        let urlFile: string = '';
        let params = {
            operation: operationId
        }
        let response = await this.apiService.get('order/budget-quota-report-excel', params);
        if(response?.data){
            urlFile = environment.URL_API_BACKEND.replace(/api\/$/, '') + 'dmz/sandbox/' + response.data;
        }
        return urlFile;        
    }
    
    async submitQuotaBudgetToDispatch(operationId: number, customerAreaId: number, additionalQuotaInSector: Array<{ sector: number, quotaQuantity: number}>): Promise<ActionDone|null> {
        let actionDone: ActionDone|null = null;
        let body = {
            operation: operationId,
            customerArea: customerAreaId,
            additionalQuotaInSector: additionalQuotaInSector
        };
        let response = await this.apiService.put('operation/' + operationId + '/customer-area/' + customerAreaId + '/dispatch-additional-quota', body);
        if(response?.data){
            actionDone = response.data;
        }
        return actionDone;
    }    
    
    async submitQuotaBudgetToTransferGlobal(quotaFromId: number, quotaToId: number, transfertQty: number): Promise<ActionDone|null>{
        let actionDone: ActionDone|null = null;
        let body = {
            sourceCustomerOrderQuota: quotaFromId,
            destCustomerOrderQuota: quotaToId,
            transferAmount: transfertQty
        };        
        let response = await this.apiService.put('operation/customerorder-budget-quota-transfert', body);
        if(response?.data){
            actionDone = response.data;
        }        
        return actionDone;
    }
    
    async submitQuotaBudgetToTransfer(operationId: number, sectorFromId: any, sectorToId: any, transfertQty: any): Promise<ActionDone|null> {
        let actionDone: ActionDone|null = null;
        let body = {
            customerSectorFrom: sectorFromId,
            customerSectorTo: sectorToId,
            transferAmount: transfertQty
        }
        let response = await this.apiService.put('operation/' + operationId + '/customersector-budget-quota-transfer', body);
        if(response?.data){
            actionDone = response.data;
        }
        return actionDone;
    }

    async loadHourQuotaReport(operationId?: number): Promise<CustomerSectorHourQuotaReport|null> {
        let report: CustomerSectorHourQuotaReport|null = null;
        let params: any = {};
        if(operationId){
            params.operation = operationId;
        }
        let response = await this.apiService.get('order/hour-quota-report', params);
        if(response?.data){
            report = response.data;
        }
        return report;
    }
    
    async loadTransferableHoursQuotaReport(): Promise<TransferableHourQuotaReport|null> {
        let report: TransferableHourQuotaReport|null = null;
        let response = await this.apiService.get('operation/transferable-hour-quota-report');
        if(response?.data){
            report = response.data;
        }
        return report;
    }
    
    async loadExcelHourQuotaReport(operationId: number, displayAsDays: boolean = false): Promise<string> {
        let urlFile: string = '';
        let params = {
            operation: operationId,
            display_as_days: displayAsDays
        }
        let response = await this.apiService.get('order/hour-quota-report-excel', params);
        if(response?.data){
            urlFile = environment.URL_API_BACKEND.replace(/api\/$/, '') + 'dmz/sandbox/' + response.data;
        }
        return urlFile;           
    }
    
    async submitQuotaHourTransferGlobal(quotaFromId: number, quotaToId: number, transfertQty: number): Promise<ActionDone|null>{
        let actionDone: ActionDone|null = null;
        let body = {
            sourceCustomerOrderQuota: quotaFromId,
            destCustomerOrderQuota: quotaToId,
            transferAmount: transfertQty
        };
        let response = await this.apiService.put('operation/customerorder-hour-quota-transfert', body);
        if(response?.data){
            actionDone = response.data;
        }
        return actionDone;
    }
        
    async  submitQuotaHourTransfer(operationId: number, profileId: any, sectorFromId: any, sectorToId: any, transfertQty: any): Promise<ActionDone|null> {
        let actionDone: ActionDone|null = null;
        let body = {
            profile: profileId,
            customerSectorFrom: sectorFromId,
            customerSectorTo: sectorToId,
            transferAmount: transfertQty
        };
        let response = await this.apiService.put('operation/' + operationId + '/customersector-hour-quota-transfer', body);
        if(response?.data){
            actionDone = response.data;
        }
        return actionDone;        
    }
}
